
import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Form, Row, Col, FormGroup, FormControl, Button, ButtonToolbar } from 'react-bootstrap'
import { tableHelper, momentHelper } from './helpers'
import ReactPaginate from 'react-paginate'
import './report.css';
import Select from 'react-select'
import FontAwesome from 'react-fontawesome'
import SelectDate from '../../component/element/SelectDate'
import StatusText from '../../component/element/StatusText'
// import SelectObject from '../../../component/element/SelectObject'


/* 
<ReportInvoice title='ใบเสร็จรับเงิน' requestPath='/report/invoice'/>
  <ReportInvoice
  title='ใบเสร็จรับเงิน'
  searchOptions={[
    {
      label: 'ใบเสร็จรับเงิน',
      value: 'inoviceNo'
    },
    {
      label: 'ใบxxx',
      value: 'workNo'
    }]}
  data={data}
  onRequestData={this.onRequestData.bind(this)} /> 
  
  onRequestData(year,month,searchBy,query)
  *
*/

const mockJson = {
  dataList: [
    {
      issuedDate: '26/08/2560',
      invoiceNo: '400/2560',
      workNo: 'SR304.001/2560',
      clientName: 'เมืองไทยประกันชีวิต',
      amount: '5000',
      remark: '',
      status: '1'
    },
    {
      issuedDate: '25/08/2560',
      invoiceNo: '401/2560',
      workNo: 'SR304.002/2560',
      clientName: 'เมืองไทยประกันชีวิต',
      amount: '5000',
      remark: '',
      status: '2'
    }
  ]
};

class ReportInvoice extends Component {

  constructor(props) {
    super(props)
    const month = momentHelper.getMonth()
    const year = momentHelper.getYear()
    const searchBy = 'invoiceNo'
    const query = ''
    const data = this.requestData(year, month, searchBy, query)

    this.state = {
      month: month,
      year: year,
      searchBy: searchBy,
      query: query,
      pageCount: 1,
      activePage: 1,
      loading: false,
      data: data
    }
  }

  onMonthChange(val) {
    this.setState({
      month: val.value
    })

    this.loadData()
  }

  onYearChange(val) {
    this.setState({
      year: val.value
    })

    this.loadData()
  }

  onSearchOptionChange(val) {
    this.setState({
      searchBy: val.value
    })

    this.loadData()
  }

  onSearchKeyPress(target) {
    if (target.charCode === 13) {
      this.loadData()
    }
  }

  onSearchClick() {
    this.setState({
      query: this.state.query
    })

    this.loadData()
  }

  onQueryChange(e) {
    this.setState({ query: e.target.value })
  }

  requestData(year, month, searchBy, query) {
    // return getDataFromNetwork(year, month, searchBy, submitQuery)
    return mockJson.dataList
  }

  loadData() {
    const { year, month, searchBy, query } = this.state
    this.setState({ loading: true })
    // do something with request path to load data
    // this.props.requestPath


    // this.setState({
    //   loading: false,
    //   data: this.requestData(year, month, searchBy, query)
    // })
  }

  renderToolbar() {
    const searchOptions = [
      {
        label: this.props.title,
        value: 'invoiceNo'
      },
      {
        label: 'เลขรับแจ้ง/ใบงาน',
        value: 'workNo'
      }
    ]

    return (
      <Row>
        <Col lg={4} md={4} >
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
          />
        </Col>
        <Col lg={6} md={6} >
          <Form inline>
            <FormGroup style={{ width: '150px' }}>
              <Select
                value={this.state.searchBy}
                options={searchOptions}
                clearable={false}
                onChange={this.onSearchOptionChange.bind(this)}
              />
            </FormGroup>
            <FormGroup>
              <div className="input-group ">
                <FormControl
                  value={this.state.query}
                  placeholder="ค้นหา..."
                  onKeyPress={this.onSearchKeyPress.bind(this)}
                  onChange={this.onQueryChange.bind(this)}
                />
                <span className="input-group-btn">
                  <Button className='btn-flat'
                    onClick={this.onSearchClick.bind(this)}
                  >
                    <FontAwesome name='search' />
                  </Button>
                </span>
              </div>
            </FormGroup>
          </Form>
        </Col>
      </Row>
    )
  }

  renderTable() {
    const headerTitles = [
      'วันที่ออก(วัน-เดือน-ปี)',
      'เลขที่',
      'ใบงานเลขที่',
      'ประกัน/ลูกค้า',
      'มูลค่า(บาท)',
      'หมายเหตุ',
      'สถานะ'
    ]

    // add status text component to data array
    const dataRows = this.state.data.map((row, rid) => {
      const newRow = JSON.parse(JSON.stringify(row))
      newRow.status = <StatusText value={row.status} />
      return newRow
    })

    return (
      <table className='table table-responsive table-hover table-bordered-solid'>
        {tableHelper.renderHeader(headerTitles)}
        <tbody>
          {tableHelper.renderRows(dataRows)}
        </tbody>
        {tableHelper.renderHeader(headerTitles)}
      </table>
    )
  }

  onPageChange(page) {
    console.log('pageChagne', page)
  }

  renderPaging() {
    return (
      <Row>
        <Col md={12} >
          <ReactPaginate
            previousLabel={"ก่อนหน้า"}
            nextLabel={"ถัดไป"}
            breakLabel={<a href="">...</a>}
            breakClassName={"break-me"}
            pageCount={this.state.pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={2}
            onPageChange={this.onPageChange.bind(this)}
            containerClassName={"pagination pull-right"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"} />
        </Col>
      </Row>
    )
  }

  render() {
    const titile = 'ตาราง' + this.props.title
    return (
      <Box loading={this.state.loading}>
        <Box.Header border={true}>
          <Box.Title>{titile}</Box.Title>
        </Box.Header>
        <Box.Body>
          {this.renderToolbar()}
          {this.renderTable()}
          {this.renderPaging()}
        </Box.Body>
      </Box>
    )
  }
}

export default ReportInvoice;

ReportInvoice.defaultProps = {
  title: 'ใบเสร็จ'
}




// WEBPACK FOOTER //
// ./src/view/report/ReportInvoice.js